<template>
  <div class="dashboard main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Informações do afiliado</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row>
          <b-col>
            <div class="box-cj">
              <div class="header">
                Dados do afiliado
              </div>
              <div class="content">
                <validation-observer ref="affiliateForm" v-slot="{ invalid }">
                  <b-row class="mb-2">
                    <b-col v-if="affiliate.client_id != null">
                      <label class="cj-label">Cliente</label>
                      <b-form-input type="text" v-model="affiliate.client.name" disabled></b-form-input>
                    </b-col>
                    <b-col v-else>
                      <label class="cj-label">Nome</label>
                      <b-form-input type="text" v-model="name" :disabled="!canEdit"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">URL</label>
                      <validation-provider name="url" :rules="{ required: true, regex: '^[a-z0-9]+(?:-[a-z0-9]+)*$' }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="affiliate.slug" :disabled="!canEdit" :class="{ 'error': errors.length > 0 }"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="affiliate.id != null">
                    <b-col>
                      <label class="cj-label">Nº de clientes</label>
                      <b-form-input type="text" :value="affiliate.clients_count" :disabled="true"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Data de cadastro</label>
                      <b-form-input type="text" :value="affiliate.created_at" :disabled="true"></b-form-input>
                    </b-col>
                  </b-row>
                </validation-observer>
              </div>
              <div class="footer" v-if="canEdit">
                <b-button variant="primary" class="mr-3" @click="saveAffiliate">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        canSee: true,
        canManage: true,
        canEdit: true,

        url: '',
        newTerm: '',

        name: null,
        affiliate: {
          id: null,
          name: null,
          slug: null,
          clients_count: 0,
          created_at: null,
        }
      }
    },
    mounted () {
      this.canSee = true;
      this.canManage = true;
      this.canEdit = true;

      this.url = 'afiliados';
      this.newTerm = 'cadastrar-afiliado';

      if(this.$route.params.id != this.newTerm) {
        this.eventBus.$emit('IS_LOADING', true);
        this.api.getAffiliate(this.$route.params.id).then(res => {
          let affiliateData = res.data;
          this.affiliate = affiliateData;

          this.name = this.affiliate.name;
          this.affiliate.created_at = this.moment(affiliateData.created_at).format('DD/MM/YYYY');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Affiliate', res);

          this.eventBus.$emit('IS_LOADING', false);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.$router.push({path: '/'});

          this.$swal('Ops...', 'Não conseguimos carregar os dados do afiliado! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Affiliate', err.response);
        });
      }
    },
    watch: {
      name: function() {
        this.affiliate.name = this.name;
        this.affiliate.slug = this.slugify(this.name);
      }
    },
    methods: {
      saveAffiliate () {
        let affiliateData = {
          id: this.affiliate.id,
          name: this.affiliate.name,
          slug: this.affiliate.slug,
        };

        if (this.affiliate.id == null) {
          this.api.storeAffiliate(affiliateData).then(res => {
            if (res.status == 201) {
              this.$router.push({path: '/' + this.url});

              this.$swal('Uhull \\o/', 'O afiliado foi cadastradado com sucesso!', 'success');
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao cadastrar o afiliado! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Affiliate', res);
          }).catch(err => {

            let msg = 'Não conseguimos cadastrar o afiliado! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 400:
                msg = err.response.data.message;
                break;
              case 422:
                msg = err.response.data.errors.join('\r\n');
                break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Affiliate', err.response);
          });
        }
        else {
          this.api.updateAffiliate(this.affiliate.id, affiliateData).then(res => {
            if (res.status == 201) {
              this.$router.push({path: '/' + this.url});

              this.$swal('Uhull \\o/', 'O afiliado foi atualizado com sucesso!', 'success');
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar o afiliado! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Affiliate', res);
          }).catch(err => {

            let msg = 'Não conseguimos atualizar o afiliado! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 400:
                msg = err.response.data.message;
                break;
              case 422:
                msg = err.response.data.errors.join('\r\n');
                break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Affiliate', err.response);
          });
        }
      },
      slugify(text) {
        return text
            .toString()                     // Cast to string
            .toLowerCase()                  // Convert the string to lowercase letters
            .normalize('NFD')       // The normalize() method returns the Unicode Normalization Form of a given string.
            .trim()                         // Remove whitespace from both sides of a string
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w-]+/g, '')       // Remove all non-word chars
            .replace(/--+/g, '-');        // Replace multiple - with single -
      }
    }
  }
</script>

<style lang="scss">
  .dashboard {
    padding: 20px 0;

    .header-info {
      p {
        margin: 0;
      }

      .info {

      }

      .value {
        font-size: 32px;
        color: $linkWater;
      }
    }
  }
</style>
